<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                Professional Development
              </p>
              <p class="product-subtitle">
                Enabling you to implement today’s best practices in the classroom!
              </p>
              <p class="product-description">
                Supports each teacher’s pedagogy through the holistic Fun Learning philosophy.
                 Includes extensive onsite and online training. Universally adaptable to fit local curricular goals and cultures.
                  Encourages educators to make learning FUN and promote essential life skills among preschoolers, and focus on their overall wellbeing.
              </p>
              <p class="product-cta">
                <a href="javascript:;" @click="moreInfo = !moreInfo" class="button button-large button-secondary">{{moreInfo?'Read Less':'Read More'}}</a>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/professional-development.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-light section-description" v-if="moreInfo">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p class="subsection-title">
                We believe every teacher is a future astronaut trainer!
              </p>
              <p class="subsection-subtitle">
                Teaching is a lifelong learning process. Fun Academy Professional Development offers continuous onsite and online teacher training in Fun Learning
                 throughout the year.
              </p>
            </div>
          </div>

          <section-bullets :items="readMoreItems"></section-bullets>
        </div>
      </div>
    </section>

    <section class="hero section-services" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <strong>Professional Development Solutions</strong>
              </p>
            </div>
          </div>

          <div class="columns" v-for="(solution, index) in services" :key="index">
            <div class="column is-two-thirds" :class="{ 'is-offset-one-third': index % 2 !== 0 }">
              <service-card :data="solution" :isReverse="index % 2 !== 0" :onClick="loadResource"></service-card>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="hero is-light section-testimonies">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p>
                ”We have seen how investing in professional development of our staff pays off as clear ROI,
                 and we appreciate the Fun Learning approach that makes it FUN to teach and learn.”
              </p>
              <small>Kai Seppälä<br><i>CFO of Pilke Kindergarten chain, Finland</i></small>
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionContact from '@/components/SectionContact'
import SectionBullets from '@/components/SectionBullets'
import ServiceCard from '@/components/ServiceCard'
import Button from '@/components/Button'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'kinderpage',

  components: {
    PublicLayout,
    SectionContact,
    SectionBullets,
    ServiceCard,
    Button
  },

  created () {
    this.fetchPds()
  },

  computed: {
    ...mapState('services', {
      services: state => state.pds,
      isLoading: state => state.isFetching
    })
  },

  methods: {
    ...mapActions('services', ['fetchPds']),

    loadResource (id) {
      this.$router.push({ name: 'service', params: { id: id } })
    }
  },

  data () {
    return {
      moreInfo: false,
      readMoreItems: [
        `<strong>Tailor teaching methods</strong> to the unique learning strategies and needs of each child.`,
        `<strong>Use technology and learning environments</strong> in an effective and meaningful way, to support learning through play and exploration.`,
        `<strong>Promote a growth mindset</strong> towards learning among children.`,
        `<strong>Help children acquire healthy lifestyle habits</strong> and discover the right balance between activity and rest.`
      ],
      solutions: [
        {
          title: 'Educator Training',
          description: 'For early years educators & K-2 teachers of children aged 3 to 6. Provides continuous professional development in Fun Learning throughout the year. Supports bringing core life skills to the classroom to help children understand how the world works, identify their strengths and ignite a passion for lifelong learning.',
          img: '/static/img/assets/educator-training.png',
          to: { name: 'educator' }
        },
        {
          title: 'Trainer Training Program',
          description: 'For experienced early-years professionals interested in becoming Fun Academy Trainers! Combines the strong Finnish educators’ mindset with core life skills and present-day opportunities to take learning to the next level. Includes on-site training in Finland and continues throughout the year with online modules.',
          img: '/static/img/assets/trainer-training.png',
          to: { name: 'trainer' }
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.product-title{
  color: #0A2239;
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 1.125rem;
}

.product-subtitle{
  color: #363636;
  font-size: 1.25rem;
  line-height: 1.6;
}

.product-description{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 2rem;
}

.product-cta{
  margin-top: 1.5rem;
}

.character-correction{
  margin-bottom: -6rem;
}

.subsection-subtitle{
    color: #6B7285;
    font-size: 1rem;
    margin-top: 1.6rem;
}

.section-testimonies{
  p{
    color: #6B7285;
    font-style: italic;
    font-size: 1.625rem;
    line-height: 1.55;
  }
  small{
    display: block;
    font-size: 1rem;
    padding-top: 1rem;
    i{
      color: #6B7285;
    }
  }
}

.section-cta{
  .hero-body{
    padding-bottom: 0;
  }

  .image-wrapper{
    overflow:hidden;
    height: 400px;
  }
}

.product-image{
  width: 480px;
  height: 320px;
}

.section-services{
  .box{
    button{
      margin-right: 1rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/PDPage.vue